import { useFormApi } from "@avinet/adaptive-ui-core/form/useForm";
import Grow from "@avinet/adaptive-ui-core/layout/Grow";
import Row from "@avinet/adaptive-ui-core/layout/Row";
import { useTranslate } from "@avinet/adaptive-ui-translate";
import useFormTree from "../../../hooks/useFormTree";
import Survey from "../../../types/Survey";
import { Icon } from "../../Icon";
import { LayoutRenderer, LayoutRendererProps } from "../FormRenderer";
import SectionRenderer from "../SectionRenderer";
import PlainGroupRenderer from "./PlainGroupRenderer";
import "./PlainLayoutRenderer.scss";

const PlainLayoutRenderer: LayoutRenderer = ({
  survey,
}: LayoutRendererProps) => {
  const t = useTranslate("LayoutRenderer");
  const { title, schema, groups } = survey;
  const tree = useFormTree(schema, groups, { ignoreAdministrative: true });
  const form = useFormApi<Survey>();

  return (
    <>
      <header>
        <img
          className="logo"
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII="
          alt=""
        />
      </header>
      <form className="plain-form" onSubmit={form.submit}>
        <h1>{title}</h1>
        {schema.length === 0 && <p>{t("emptySchema")}</p>}
        {tree.map((entry, entryIdx) => {
          const children = entry.children.map((section) => {
            return (
              <SectionRenderer key={section.idx} section={section.section} />
            );
          });

          if (entry.group) {
            return (
              <PlainGroupRenderer key={entryIdx} group={entry.group}>
                {children}
              </PlainGroupRenderer>
            );
          }
          return children;
        })}
        <Row>
          <Grow />
          <button type="submit" className="btn">
            <Icon name="checkmark" /> {t("submit")}
          </button>
        </Row>
      </form>
    </>
  );
};

export default PlainLayoutRenderer;
